<template>
  <div class="banner-slide-area">
    <BannerSlideOne :custom-images="banner.slide_row_1 || []" />

    <BannerSlideTwo :custom-images="banner.slide_row_2 || []" />

    <BannerSlideThree :custom-images="banner.slide_row_3 || []" />

    <div class="banner-content-wrap">
      <div class="container">
        <div
          class="banner-content"
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-delay="100"
        >
          <span class="top-title">{{ banner.top_title }}</span>
          <h1>{{ banner.title }}</h1>
          <p>{{ banner.subtitle }}</p>
          <div class="banner-cta">
            <RouterLink :to="banner.cta_url || '/pricing'" class="btn">
              <span class="border-style">{{ banner.cta_text || "Buy Now" }}</span>
            </RouterLink>
          </div>
          <ul
            class="ps-0 mb-0 list-unstyled d-flex align-items-center flex-wrap several-list gap-2 gap-lg-3 justify-content-center"
          >
            <li v-for="(point, i) in banner.bullet_points" :key="i" class="d-flex align-items-center">
              <i class="ti ti-circle-check"></i>
              <span>{{ point }}</span>
            </li>
          </ul>
        </div>

        <ul
          class="partner-logo ps-0 mb-0 list-unstyled d-none d-md-flex justify-content-lg-between flex-wrap gap-3 align-items-center justify-content-center"
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-delay="200"
        >
          <li v-for="(p, i) in effectivePartners" :key="i">
            <img :src="p.image" alt="partner" />
          </li>
        </ul>

        <PartnerSlide :custom-images="banner.partner_logos || []" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from "vue";
import BannerSlideOne from "./BannerSlideOne.vue";
import BannerSlideTwo from "./BannerSlideTwo.vue";
import BannerSlideThree from "./BannerSlideThree.vue";
import PartnerSlide from "./PartnerSlide.vue";
import { useContent } from "@/composables/useContent";

const defaultPartners = [
  require("@/assets/images/partner-7.png"),
  require("@/assets/images/partner-8.png"),
  require("@/assets/images/partner-9.png"),
  require("@/assets/images/partner-10.png"),
  require("@/assets/images/partner-11.png"),
];

export default defineComponent({
  name: "MainBanner",
  components: {
    BannerSlideOne,
    BannerSlideTwo,
    BannerSlideThree,
    PartnerSlide,
  },
  setup() {
    const { content: banner } = useContent("banner", {
      top_title: "FAST IPTV CONNECTION",
      title: "Enjoy Top Quality Streaming With GoPlayTV",
      subtitle: "Includes all your favorite channels with local news, live sports, weather,",
      bullet_points: [
        "Connect several devices at once",
        "25,000 worldwide channels 4K",
        "500K new and old movies",
      ],
      cta_text: "Buy Now",
      cta_url: "/pricing",
      logo_image_url: "",
      partner_logos: [{ image_url: "" }, { image_url: "" }, { image_url: "" }, { image_url: "" }, { image_url: "" }],
      slide_row_1: [{ image_url: "" }, { image_url: "" }, { image_url: "" }, { image_url: "" }],
      slide_row_2: [{ image_url: "" }, { image_url: "" }, { image_url: "" }, { image_url: "" }],
      slide_row_3: [{ image_url: "" }, { image_url: "" }, { image_url: "" }, { image_url: "" }, { image_url: "" }],
    });
    const effectivePartners = computed(() => {
      const cms = (banner.value.partner_logos || []).filter((p: any) => p.image_url).map((p: any) => ({ image: p.image_url }));
      return cms.length > 0 ? cms : defaultPartners.map((img) => ({ image: img }));
    });

    return { banner, effectivePartners };
  },
});
</script>
